import { render } from "./FirstPage.vue?vue&type=template&id=1d0db346"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"

import "./FirstPage.vue?vue&type=style&index=0&id=1d0db346&lang=css"

import exportComponent from "C:\\Users\\amirhossein\\Project\\emad_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__